import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Button,
  Chip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";

interface TrainingRandomGameProps {
  abilities?: any;
  name?: string | null;
  image?: string | undefined;
  id?: string;
  onClick?: any;
}
export const TrainingRandomGame = ({
  abilities,
  name,
  image,
  onClick,
}: TrainingRandomGameProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      onClick={onClick}
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        borderRadius: "13px",
        width: "100%",
        height: { xs: "318px", sm: "159px" },
        backgroundColor: "#2CA6A41F",
        border: "solid 1px #2CA6A4AD",
        overflow: "hidden",
        cursor: "pointer",
        gap: { xs: 1, sm: 2 },
      }}
    >
      {/* IMAGEM */}
      <Box>
        <Box
          sx={{
            width: { xs: "100%", sm: "283px" },
            height: { xs: "170px", sm: "100%" },
            flexShrink: 0,
            position: "relative",
            overflow: "hidden",
            borderRadius: "13px 13px 0 0",
            "&:hover .play-button": isMobile
              ? {
                  opacity: 1,
                  visibility: "visible",
                }
              : {},

            "&:hover img": isMobile
              ? {
                  filter: "brightness(0.2)",
                }
              : {},
          }}
        >
          <img
            src={image}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />

          {isMobile && (
            <Box
              className="play-button"
              onClick={onClick}
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",

                width: 150,
                height: 44,

                opacity: 0,
                visibility: "hidden",
                transition: "all .3s ease",
                borderRadius: "25px",
                border: "3px solid #fff",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",

                color: "#fff",
                cursor: "pointer",
                textTransform: "uppercase",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              Jogar
            </Box>
          )}
        </Box>
      </Box>
      {/* CONTEÚDO */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "flex-start", sm: "center" },
          width: "100%",
          padding: { xs: "7px", sm: "9px", md: "16px" },
          gap: { xs: 1, sm: 2 },
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          <Box sx={{ color: "#159E9C", display: "flex", gap: 1 }}>
            <SportsEsportsOutlinedIcon />
            <Typography sx={{ fontSize: { xs: "14px", sm: "16px" } }}>
              {t("global.recommendation")}
            </Typography>
          </Box>
          <Typography
            sx={{
              color: "#232425",
              fontWeight: 600,
              fontSize: { xs: "16px", md: "20px" },
            }}
          >
            {name}
          </Typography>
          <Box sx={{ display: "flex", gap: "5px", flexWrap: "wrap" }}>
            {abilities.map((ability: any) => (
              <Chip
                key={ability}
                label={ability}
                sx={{
                  backgroundColor: "#2CA6A42B",
                  color: "#319C9A",
                  fontWeight: 500,
                  fontSize: { xs: "10px", sm: "13px" },
                }}
              />
            ))}
          </Box>
        </Box>
        <Button
          sx={{
            display: { xs: "none", sm: "flex" },
            border: "solid 1px #007085",
            color: "#007085",
            width: "120px",
            height: { xs: "30px", sm: "35px" },
            borderRadius: "15px",
            fontSize: { xs: "12px", md: "16px" },
            marginRight: { xs: 0, sm: "20px" },
          }}
          onClick={onClick}
        >
          {t("global.play")}
        </Button>
      </Box>
    </Box>
  );
};
